import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'
import { getSafeRedirect } from 'utils/redirect'

const PublicRoute = () => {
	const { token } = useSelector((state) => state.auth)
	const location = useLocation()

	// Once a token appears (after login) this guard re-renders before the login form's own
	// effect can run, so the ?redirect= target has to be honoured here.
	return token ? <Navigate to={getSafeRedirect(location.search, AUTHENTICATED_ENTRY)} replace /> : <Outlet />
}

export default PublicRoute
